import { Box, Grid, Typography } from '@mui/material'
import React from 'react'
import { useSelector } from 'react-redux';
import './ProductDetailSale.css'
import { currencyFormatter } from 'helpers/util';
import theme from 'config/theme';

const ProductDetailSale = () => {
  const { selectedProduct } = useSelector(store => store.airTimeSale);
  const productInfo = [
    {
      label: 'Datos',
      value: selectedProduct?.gb ? selectedProduct?.gb + 'MB' : null,
      borders: ['b', 'r']
    },
    {
      label: 'Vigencia',
      value: selectedProduct?.vig ? selectedProduct?.vig + ' ' + (selectedProduct?.vig === '1' ? 'día' : 'días') : null,
      borders: ['b', 'r']
    },
    {
      label: 'Minutos',
      value: selectedProduct?.min,
      borders: ['b', 'r']
    },
    {
      label: 'SMS',
      value: selectedProduct?.sms,
      borders: ['b']
    },
    {
      label: 'Redes Sociales',
      borders: ['r'],
      value: selectedProduct?.extraDenomination?.map(({ fd, description }, key) => (
        <div
          className='extraDenominationImage'
          title={description}
          style={{
            backgroundImage: `url(/v3/file/${fd}/)`,
            backgroundPosition: 'center',
            backgroundSize: 'contain',
            backgroundRepeat: 'no-repeat',
          }}
        />
      ))
    },
    {
      label: 'Tipo',
      value: selectedProduct?.type ? selectedProduct?.type : null,
      borders: ['r']
    },
    {
      label: 'Monto',
      value: selectedProduct?.imp ? currencyFormatter.format(selectedProduct?.imp) : null,
      borders: ['r']
    },
    {
      label: '-',
      value: null,
      borders: []
    },
  ];
  return (
    <Box my={2}>
      <Typography variant="h6" px={2} py={1}>Operadora: {selectedProduct?.company}</Typography>
      <Grid container justifyContent="center" alignItems="center" mt={-5}>
        <Box
          bgcolor={selectedProduct?.image ? '#FFFFFF' : '#D9D9D9'}
          height={100}
          width={100}
          borderRadius={25}
          border={'3px solid #041C3F'}
        // position={'absolute'}
        >
          <img
            src={`/v3/file/${selectedProduct?.image}/`}
            alt={selectedProduct?.company}
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'contain',
              borderRadius: 50,
            }}
          />
        </Box>
      </Grid>
      <Box bgcolor={theme.contrastColor} borderRadius={2} border={'3px solid ' + theme.secundaryColor} overflow="hidden" mt={-7.5}>
        <Typography variant="h6" bgcolor={theme.secundaryColor} color='#FFFFFF' py={.5} px={2} >
          Información de producto
        </Typography>
        <Grid container p={2}>
          {
            productInfo.map((info, index) => (
              <Grid item xs={12} sm={6} md={3} key={index} pt={1} justifyItems="center" alignItems="center"
                sx={{
                  borderBottom: info.borders.includes('b') && '1px solid #FFFFFF',
                  borderRight: info.borders.includes('r') && '1px dashed #FFFFFF',
                  borderLeft: info.borders.includes('l') && '1px dashed #FFFFFF',
                }}
              >
                <Typography color='#FFFFFF' fontSize={28}>{info.label}:</Typography>
                {
                  Array.isArray(info.value) && info.value.length > 0 ? (
                    <Grid container spacing={1} mt={1}>
                      {info.value.map((item, key) => (
                        <Grid item key={key}>
                          {item}
                        </Grid>
                      ))}
                    </Grid>
                  ) : <Typography color='#FFFFFF' fontSize={28} fontWeight="bold" textAlign={'center'}>{info.value || '-'}</Typography>
                }
              </Grid>
            ))
          }
        </Grid>
      </Box>
    </Box>
  )
}

export default ProductDetailSale